/* R24 · Unvollständige letzte Zeile mittig (Owner 23.09.2026: „alle Streifen und Reihen zentriert“).
   Karten-Raster (CSS-Grid mit festen oder auto-fill-Spalten) lassen die letzte Zeile links stehen —
   z. B. 3 Beiträge in 2 Spalten, 3 von 4 Ansichten, 1 Serie von 4. CSS kann die letzte Grid-Zeile
   nicht zentrieren; hier wird sie gemessen und mit der Einzel-Eigenschaft `translate` verschoben
   (setzt sich mit Hover-`transform` der Karten zusammen, ändert kein Layout → kein CLS).
   Neu berechnet bei Größenänderung und wenn Karten nachgeladen werden („Mehr laden“, Filter).
   Neue Raster: Attribut data-r24-center-rows setzen oder Selektor unten ergänzen. */
(function () {
  var SEL = '[data-r24-center-rows],.r24mag,#r24col-grid,.r24tb-gal__grid,.r24ar__prodgrid,.r24as-grid,.r24-facts,.r24pof__grid,.r24pd-glance>.grid';
  function visible(el) { return el.offsetParent !== null && getComputedStyle(el).position !== 'absolute'; }
  function center(box) {
    var kids = [].filter.call(box.children, visible);
    kids.forEach(function (k) { k.style.translate = ''; });
    if (kids.length < 2) return;
    var rows = [], last = null;
    kids.forEach(function (k) {
      var t = k.offsetTop;
      if (!last || Math.abs(t - last.t) > 4) { last = { t: t, els: [] }; rows.push(last); }
      last.els.push(k);
    });
    if (rows.length < 2) return;
    var lr = rows[rows.length - 1].els, fr = rows[0].els;
    if (lr.length >= fr.length) return;
    var cs = getComputedStyle(box), b = box.getBoundingClientRect();
    var L = b.left + box.clientLeft + parseFloat(cs.paddingLeft), R = b.right - parseFloat(cs.paddingRight);
    var a = lr[0].getBoundingClientRect().left, z = lr[lr.length - 1].getBoundingClientRect().right;
    var shift = ((R - z) - (a - L)) / 2;
    if (Math.abs(shift) < 2) return;
    lr.forEach(function (k) { k.style.translate = Math.round(shift) + 'px 0'; });
  }
  var queued = new Set(), raf = 0;
  /* setTimeout statt requestAnimationFrame: rAF ruht in Hintergrund-Tabs/Vorschau-Fenstern. */
  function soon(box) { queued.add(box); if (!raf) raf = setTimeout(function () { raf = 0; var q = Array.from(queued); queued.clear(); q.forEach(center); }, 30); }
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (es) { es.forEach(function (e) { soon(e.target); }); }) : null;
  var mo = 'MutationObserver' in window ? new MutationObserver(function (ms) { ms.forEach(function (m) { soon(m.target); }); }) : null;
  var seen = new WeakSet();
  function scan() {
    [].forEach.call(document.querySelectorAll(SEL), function (box) {
      if (seen.has(box)) return; seen.add(box);
      soon(box);
      if (ro) ro.observe(box);
      if (mo) mo.observe(box, { childList: true });
    });
  }
  scan();
  window.addEventListener('load', scan);
  /* Später eingefügte Raster (Sektions-Nachladen, Tabs). */
  var st = 0;
  if (mo) new MutationObserver(function () { if (!st) st = setTimeout(function () { st = 0; scan(); }, 250); }).observe(document.body, { childList: true, subtree: true });
})();
